import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import ButtonPrimary from "../../../elements/button/ButtonPrimary";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import {
  MenuIcon,
  PencilIcon,
  PlusIcon,
  TrashIcon,
} from "@heroicons/react/outline";
import SMModal from "../../../elements/modals/SMModal";
import { connect } from "react-redux";
import ReactDragListView from "react-drag-listview/lib/index.js";
import axiosAPI from "../../../utils/axios-api";

const API = process.env.REACT_APP_API;
const kode_kuesioner = Math.floor(Math.random() * 9000000000) + 1000000000;

const EditPertanyaan = (props) => {
  let pilihanTemp = [];
  props.initialPilihan.forEach((element) => {
    pilihanTemp.push({ value: element });
  });

  const [pilihan, setpilihan] = useState(pilihanTemp);
  const [pertanyaan, setpertanyaan] = useState(props.initialPertanyaan);

  // setpertanyaan(soal[idxEdit].soal)

  function increasePilihan(params) {
    setpilihan([...pilihan, { value: "" }]);
  }

  function decreasePilihan(params) {
    let index = params;
    let temp = pilihan.filter((x, y) => y !== index);
    console.log(temp);

    setpilihan(temp);
  }

  function setValueFirst(e) {
    let dataTemp = pilihan;
    dataTemp[0].value = e.target.value;

    setpilihan(dataTemp);
  }

  function setValue(e, val, idx) {
    let dataTemp = pilihan;
    dataTemp[idx].value = e.target.value;

    setpilihan(dataTemp);
  }

  function save(params) {
    let pilihanTemp = [];
    pilihan.forEach((element) => {
      pilihanTemp.push(element.value);
    });
    let dataTemp = props.allSoal;
    dataTemp[params] = { soal: pertanyaan, pilihan: pilihanTemp };
    props.save(dataTemp);
    localStorage.setItem("temp_soal_pilihanganda", JSON.stringify(dataTemp));
    batal();
  }

  function batal(params) {
    props.batal();
  }
  return (
    <>
      <div className="flex flex-row justify-between py-4">
        <h1 className="text-2xl font-bold">
          Form edit pertanyaan -{" "}
          <span className="bg-gray-300 px-4 py-2 rounded">
            {props.initialPertanyaan.substr(0, 8)} ...
          </span>
        </h1>
        <div className="flex flex-row">
          <button
            onClick={() => batal()}
            className="px-4 py-2 rounded bg-red-200 text-red-500"
          >
            Batal
          </button>

          <button
            onClick={(e) => save(props.indexEdit - 1)}
            className="px-4 py-2 rounded bg-blue-400 ml-2 text-white"
          >
            Simpan
          </button>
        </div>
      </div>
      <div className="flex flex-row">
        <div className="w-1/2 pr-4">
          <p className="my-2">Pertanyaan</p>
          <textarea
            className="text-black w-full text-sm bg-gray-200 dark:text-gray-200 dark:bg-gray-600 p-1 rounded-lg mb-4"
            id="w3review"
            name="w3review"
            rows="5"
            cols="50"
            onChange={(e) => setpertanyaan(e.target.value)}
          >
            {pertanyaan}
          </textarea>
        </div>
        <div className="w-1/2">
          <div className="flex flex-col">
            <p className="my-2">Pilihan</p>
            <div className="flex flex-row items-center">
              <div className="flex items-center">
                <textarea
                  className="text-black flex-1 text-sm bg-gray-200 dark:text-gray-200 dark:bg-gray-600 p-1 rounded-lg mb-4"
                  id="w3review"
                  name="w3review"
                  rows="2"
                  cols="50"
                  onChange={(e) => {
                    setValueFirst(e);
                  }}
                >
                  {pilihan[0]?.value}
                </textarea>
              </div>
              <button
                className="p-1 ml-2 text-white rounded bg-blue-500"
                onClick={() => increasePilihan()}
              >
                <PlusIcon className="h-4 w-4" />
              </button>
            </div>
            {pilihan.slice(1, pilihan.length).map((val, idx) => (
              <>
                <p className="mb-2">Pilihan</p>
                <div className="flex flex-row items-center">
                  <div className="flex items-center">
                    <textarea
                      className="text-black flex-1 text-sm bg-gray-200 dark:text-gray-200 dark:bg-gray-600 p-1 rounded-lg mb-4"
                      id="w3review"
                      name="w3review"
                      rows="2"
                      cols="50"
                      onChange={(e) => {
                        setValue(e, val, idx + 1);
                      }}
                    >
                      {val.value}
                    </textarea>
                  </div>
                  <button
                    className="p-1 ml-2 text-white rounded bg-red-500"
                    onClick={() => decreasePilihan(idx)}
                  >
                    <TrashIcon className="h-4 w-4" />
                  </button>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const BuatKuesionerPilihanGanda = (props) => {
  const history = useHistory();
  const trackButton = useRef();

  // STUFF
  const [kuesioner, setkuesioner] = useState({});
  const [state, setState] = useState({
    isPaneOpen: false,
  });
  const [paneEdit, setpaneEdit] = useState(null);
  const [idxEdit, setidxEdit] = useState(0);
  const [modalDelete, setmodalDelete] = useState(null);
  const [soalToDelete, setsoalToDelete] = useState("");
  const [soal, setsoal] = useState([]);

  const [modalSimpan, setmodalSimpan] = useState(false);
  const [statusSimpan, setstatusSimpan] = useState(0);
  const [number, setnumber] = useState(0);

  // SERVICES
  useEffect(() => {
    let dataSoal =
      JSON.parse(localStorage.getItem("temp_soal_pilihanganda")) ?? [];
    let dataKuesioner = JSON.parse(
      localStorage.getItem("temp_create_kuesioner")
    );

    if (!!dataKuesioner) {
      setkuesioner(dataKuesioner);
    }

    setsoal(dataSoal);
  }, []);

  function countDown(params) {
    let number = params ?? 3;
    setnumber(params);
    if (number > 0) {
      setInterval(() => {
        number = number - 1;
        if (number >= 0) {
          setnumber(number);
        }
      }, 1000);
    }
  }
  function create(params) {
    // status simpan
    // 0 = IDLE
    // 1 = SUCCEDDED
    // 2 = FAILED
    // 3 = ON_PROCCESS

    setstatusSimpan(3);
    let body = {
      info_panduan: kuesioner,
      pilihan_ganda: soal,
      kode_kuesioner: "10" + kode_kuesioner,
    };

    axiosAPI
      .post(API + "kuesioner/create-pilihan-ganda", body)
      .then((res) => {
        setstatusSimpan(1);
        localStorage.removeItem("temp_soal_pilihanganda");
        localStorage.removeItem("temp_create_kuesioner");
        localStorage.removeItem("queue_create_kuesioner");

        countDown(3);
        setTimeout(() => {
          window.location.replace("/daftar-kuesioner");
        }, 3000);
      })
      .catch((err) => {
        setstatusSimpan(2);
        localStorage.setItem(
          "queue_create_kuesioner",
          JSON.stringify({
            kuesioner: "temp_create_kuesioner",
            type: "pilihan_ganda",
          })
        );
      });

    // history.push("/buat/isi-kuesioner-pilihan-ganda");
  }

  // View Modal Simpan
  function viewModalSimpan(params) {
    if (statusSimpan === 3) {
      return (
        <div className="p-4">
          <p>Sedang menyimpan data ...</p>
        </div>
      );
    } else if (statusSimpan === 2) {
      return (
        <div className="p-4">
          <p>Gagal menyimpan data</p>
          <div className="flex flex-row py-6 gap-2">
            <button
              onClick={() => create()}
              className="flex flex-row items-center rounded px-4 py-2 bg-blue-400 text-white"
            >
              Ulangi
            </button>
          </div>
        </div>
      );
    } else if (statusSimpan === 1) {
      return (
        <div className="p-4">
          <p>
            Berhasil menyimpan data, anda akan dialihkan ke halaman daftar
            kuesioner dalam {number} detik
          </p>
          <div className="flex flex-row py-6 gap-2"></div>
        </div>
      );
    }
    return (
      <div className="p-4">
        <p>Cek kembali data anda</p>
        <div className="flex flex-row py-6 gap-2">
          <button
            onClick={() => setmodalSimpan(!modalSimpan)}
            className="flex flex-row items-center rounded px-4 py-2 bg-red-400 text-white"
          >
            Batal
          </button>
          <button
            onClick={() => create()}
            className="flex flex-row items-center rounded px-4 py-2 bg-blue-400 text-white"
          >
            Lanjut menyimpan kuesioner
          </button>
        </div>
      </div>
    );
  }

  // FORM CREATE PERTANYAAN
  function FormPertanyaan(params) {
    const [pilihan, setpilihan] = useState([
      { value: "" },
      { value: "" },
      { value: "" },
      { value: "" },
    ]);

    const [pertanyaan, setpertanyaan] = useState("");

    function increasePilihan(params) {
      setpilihan([...pilihan, { value: "" }]);
    }

    function decreasePilihan(params) {
      let index = params;
      let temp = pilihan.filter((x, y) => y !== index);
      // console.log(temp);

      setpilihan(temp);
    }

    function setValueFirst(e) {
      let dataTemp = pilihan;
      dataTemp[0].value = e.target.value;

      setpilihan(dataTemp);
    }

    function setValue(e, val, idx) {
      let dataTemp = pilihan;
      dataTemp[idx].value = e.target.value;

      setpilihan(dataTemp);
    }

    function save(params) {
      let pilihanTemp = [];
      pilihan.forEach((element) => {
        pilihanTemp.push(element.value);
      });
      let isi = { soal: pertanyaan, pilihan: pilihanTemp };
      setsoal([...soal, isi]);
      localStorage.setItem(
        "temp_soal_pilihanganda",
        JSON.stringify([...soal, isi])
      );
      trackButton.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "end",
      });
      batal();
    }

    function batal(params) {
      setState({ isPaneOpen: false });
      setpilihan([{ value: "" }, { value: "" }, { value: "" }, { value: "" }]);
      setpertanyaan("");
    }
    return (
      <>
        <div className="flex flex-row justify-between py-4">
          <h1 className="text-2xl font-bold my-2 text-black dark:text-white">
            Form buat pertanyaan - Nomor {soal.length + 1}
          </h1>
          <div className="flex flex-row">
            <div className="mr-2">
              <button
                onClick={() => batal()}
                className="px-4 py-2 flex w-full text-center justify-center flex-row items-center rounded-lg shadow-xl hover:shadow-2xl bg-red-200 text-red-500"
              >
                <p className="text-sm">Batal</p>
              </button>
            </div>

            <ButtonPrimary onClick={(e) => save()} type="solid" text="Simpan" />
          </div>
        </div>
        <div className="flex flex-row">
          <div className="w-1/2 pr-4">
            <p className="my-2 text-black dark:text-white">Pertanyaan</p>
            <textarea
              className="text-black w-full text-sm bg-gray-200 dark:text-gray-200 dark:bg-gray-600 p-1 rounded-lg mb-4"
              id="w3review"
              name="w3review"
              rows="5"
              cols="50"
              onChange={(e) => setpertanyaan(e.target.value)}
            >
              {pertanyaan}
            </textarea>
          </div>
          <div className="w-1/2">
            <div className="flex flex-col">
              <p className="my-2 text-black dark:text-white">Pilihan</p>
              <div className="flex flex-row items-center">
                <div className="flex items-center">
                  <textarea
                    className="text-black flex-1 text-sm bg-gray-200 dark:text-gray-200 dark:bg-gray-600 p-1 rounded-lg mb-4"
                    id="w3review"
                    name="w3review"
                    rows="2"
                    cols="50"
                    onChange={(e) => {
                      setValueFirst(e);
                    }}
                  >
                    {pilihan[0].value}
                  </textarea>
                </div>
                <button
                  className="p-1 ml-2 text-white rounded bg-blue-500"
                  onClick={() => increasePilihan()}
                >
                  <PlusIcon className="h-4 w-4" />
                </button>
              </div>
              {pilihan.slice(1, pilihan.length).map((val, idx) => (
                <>
                  <p className="mb-2 my-2 text-black dark:text-white">
                    Pilihan
                  </p>
                  <div className="flex flex-row items-center">
                    <div className="flex items-center">
                      <textarea
                        className="text-black flex-1 text-sm bg-gray-200 dark:text-gray-200 dark:bg-gray-600 p-1 rounded-lg mb-4"
                        id="w3review"
                        name="w3review"
                        rows="2"
                        cols="50"
                        onChange={(e) => {
                          setValue(e, val, idx + 1);
                        }}
                      >
                        {val.value}
                      </textarea>
                    </div>
                    <button
                      className="p-1 ml-2 text-white rounded bg-red-500"
                      onClick={() => decreasePilihan(idx)}
                    >
                      <TrashIcon className="h-4 w-4" />
                    </button>
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }

  function deletePerSoal(idx) {
    let tempData = soal.filter((x, y) => y !== idx);
    setsoal(tempData);
    setmodalDelete(null);
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...soal];
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      setsoal(data);
      localStorage.setItem("temp_soal_pilihanganda", JSON.stringify(data));
    },
    enableScroll: true,
    nodeSelector: "li",
    handleSelector: "section",
  };

  return (
    <>
      {/* Modal */}
      <SMModal
        title="Peringatan"
        show={!!modalDelete}
        onClose={() => setmodalDelete(null)}
      >
        <div className="p-4">
          <p>
            Anda yakin ingin menghapus soal{" "}
            <span className="px-2 py-1 bg-gray-300 rounded">
              {soalToDelete.substr(0, 8)}...
            </span>{" "}
            ini ?
          </p>
          <div className="flex flex-row py-6 gap-2">
            <button
              onClick={() => deletePerSoal(parseInt(modalDelete) - 1)}
              className="flex flex-row items-center rounded px-4 py-2 bg-red-400 text-white"
            >
              Ya
            </button>
            <button
              onClick={() => setmodalDelete(null)}
              className="flex flex-row items-center rounded px-4 py-2 bg-blue-400 text-white"
            >
              Tidak
            </button>
          </div>
        </div>
      </SMModal>

      {/* modal save kuesioner */}
      <SMModal
        title="Konfirmasi"
        show={modalSimpan}
        onClose={() => setmodalSimpan(!modalSimpan)}
      >
        {viewModalSimpan()}
      </SMModal>

      {/* add soal */}
      <SlidingPane
        closeIcon={<div>Some div containing custom close icon.</div>}
        isOpen={state.isPaneOpen}
        title="Hey, it is optional pane title.  I can be React component too."
        from="right"
        width="60vw"
        onRequestClose={() => setState({ isPaneOpen: false })}
      >
        <div className="flex flex-col">{FormPertanyaan()}</div>
      </SlidingPane>
      {/* end add soal */}

      {/* Edit Soal */}
      <SlidingPane
        closeIcon={<div>Some div containing custom close icon.</div>}
        isOpen={!!paneEdit}
        title="Hey, it is optional pane title.  I can be React component too."
        from="right"
        width="60vw"
        onRequestClose={() => setpaneEdit(null)}
      >
        <div className="flex flex-col">
          <EditPertanyaan
            indexEdit={paneEdit}
            initialPertanyaan={soal[idxEdit]?.soal ?? []}
            initialPilihan={soal[idxEdit]?.pilihan ?? []}
            allSoal={soal}
            batal={() => {
              setpaneEdit(null);
              setidxEdit(0);
            }}
            save={(e) => setsoal(e)}
          />
        </div>
      </SlidingPane>
      {/* End Edit Soal */}

      <div
        className="w-full flex flex-col dark:text-white pt-16"
        style={{ minHeight: "100vh" }}
      >
        <div
          className={`
              ${props.themes === "light" ? "bg-blur-light" : "bg-blur-dark"}
              flex flex-row justify-between w-full py-6 border-b px-6
            `}
          style={{
            top: "60px",
            // position: "-webkit-sticky",
            position: "sticky",
          }}
        >
          <h1 className="text-xl font-bold">
            BUAT INSTRUMEN <br />
            KUESIONER PILIHAN GANDA
          </h1>
          <div className="flex flex-col gap-2">
            {soal.length > 0 ? (
              <ButtonPrimary
                text="Simpan"
                type="solid"
                onClick={() => setmodalSimpan(!modalSimpan)}
              />
            ) : ("")}
            <ButtonPrimary
              text="Tambah Pertanyaan"
              type="solid"
              onClick={() => setState({ isPaneOpen: true })}
            />
          </div>
        </div>

        <div className="flex flex-col px-10 pb-10">
          <ReactDragListView {...dragProps}>
            <ol>
              {soal.map((val, idx) => {
                return (
                  <li
                    key={idx}
                    className="flex flex-row rounded-xl bg-gray-300 dark:bg-gray-500 p-8 mt-10"
                  >
                    <div className="flex justify-center items-center">
                      <section>
                        <MenuIcon className="h-6 w-6" />
                      </section>
                    </div>
                    <div className="flex flex-col flex-1">
                      <div className="flex flex-row">
                        <div className="dark:text-gray-800">
                          {/* <h1>{idx + 1}</h1> */}
                        </div>
                        <div className="flex-1 flex flex-col px-4 dark:text-white text-black">
                          <div>
                            <p>{val.soal}</p>
                          </div>

                          <div className="flex flex-col">
                            {val.pilihan.map((val, idx) => {
                              return (
                                <label
                                  key={idx}
                                  className="inline-flex items-center"
                                >
                                  <input
                                    type="radio"
                                    className="form-radio"
                                    name="radio"
                                    value="1"
                                  />
                                  <span className="ml-2">{val}</span>
                                </label>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <button
                        onClick={() => {
                          setpaneEdit(idx + 1);
                          setidxEdit(idx);
                        }}
                        className="flex flex-row items-center mb-2 rounded px-4 py-2 bg-blue-400 text-white"
                      >
                        <PencilIcon className="h-4 w-4 mr-2" />
                        <p>Edit</p>
                      </button>
                      <button
                        onClick={() => {
                          setmodalDelete(idx + 1);
                          setsoalToDelete(val.soal);
                        }}
                        className="flex flex-row items-center rounded px-4 py-2 bg-red-400 text-white"
                      >
                        <TrashIcon className="h-4 w-4 mr-2" />
                        <p>Hapus</p>
                      </button>
                    </div>
                  </li>
                );
              })}
            </ol>
          </ReactDragListView>
        </div>
      </div>
      <span ref={trackButton}></span>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    themes: state.darkmode.theme,
  };
};

export default connect(mapStateToProps)(BuatKuesionerPilihanGanda);
